import axios from '/src/common/axios';
import Utils from '@/common/utils';

export default {
  getList: function () {
    return axios.get('/api/journalImar/listForPatient', { })
  },
  refuse: function (data) {
    return axios.post('/api/journalImar/refuse', data)
  },
  chooseOrg: function(imarId, orgId) {
    return axios.get('/api/journalImar/chooseOrganizatoin?imarId=' + imarId + "&organizationId=" + orgId)
  },
  saveVisitMark: function (data) {
    return axios.post('/api/journalImar/saveVisitMark', data)
  },
  exportPdf: function (routeId) {
    return Utils.downloadFile('/api/journalImar/exportPdf/' + routeId, "ImarRoute.pdf");    
  }
}